import { create } from "zustand";
import { devtools } from "zustand/middleware";

export interface AppState {
  // UI State
  sidebarOpen: boolean;
  currentView:
    | "dashboard"
    | "map"
    | "history"
    | "import"
    | "vehicles"
    | "fleets"
    | "users"
    | "gps-data"
    | "campaigns"
    | "impression-jobs"
    | "impression-job-detail"
    | "reports"
    | "report-create"
    | "settings"
    | "profile";
  loading: boolean;
  error: string | null;
  selectedJobId: number | null;

  // Actions
  setSidebarOpen: (open: boolean) => void;
  setCurrentView: (view: AppState["currentView"]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearError: () => void;
  setSelectedJobId: (jobId: number | null) => void;
}

export const useAppStore = create<AppState>()(
  devtools(
    (set) => ({
      // Initial state
      sidebarOpen: true,
      currentView: "dashboard",
      loading: false,
      error: null,
      selectedJobId: null,

      // Actions
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      setCurrentView: (view) => set({ currentView: view }),
      setLoading: (loading) => set({ loading }),
      setError: (error) => set({ error }),
      clearError: () => set({ error: null }),
      setSelectedJobId: (jobId) => set({ selectedJobId: jobId }),
    }),
    { name: "app-store" },
  ),
);
